<!--首页模块三-->
<template>
  <div style="font-family: Alibaba">
    <!--采集产品标题-->
    <div class='title'>
      <div>
        <h1>
          <i class="el-icon-caret-right"></i>{{ cnNameThree }}
        </h1>
        <p>{{ enNameThree }}</p>
      </div>
    </div>
    <!--采集产品-->
    <el-row :span="24" class="box-width carbon background_img">
      <a href="#" class='card_box' @click='handleThreeClick()'>
        <el-col :md="12" :sm="12" :xs="24">
          <div class="div_img">
            <el-image
              class="carbon_img"
              :fit='fit'
              v-if='homeThreeVo.fullPathUrl != null'
              :src='homeThreeVo.fullPathUrl'
            />
          </div>
        </el-col>
        <el-col :md="12" :sm="12" :xs="24">
          <div class="text">
            <h4>{{ homeThreeVo.title }}</h4>
            <div v-html="homeThreeVo.briefIntroduction" class="htmlImgSize" style="color: #606266"></div>
          </div>
        </el-col>
      </a>
    </el-row>
  </div>
</template>
<script>
import { findEnNameOne, findHomeThree } from '@/api/zh'

export default {
  created () {
  },
  data () {
    return {
      enNameThree: '',
      cnNameThree: '',
      homeThreeVo: {},
      fit: 'fill',
      url: require('@assets/images/index/chanping.png'),
      url1: require('@assets/images/index/chanping1.png'),
      url2: require('@assets/images/index/chanping2.png'),
      gatherUrl: require('@assets/images/index/caiji.png')
    }
  },
  mounted () {
    this.selectThree()
  },
  methods: {
    /** 查询英文名称 */
    selectEnName (cnEnNameId) {
      let that = this
      findEnNameOne(cnEnNameId).then(res => {
        let data = res.data
        that.enNameThree = data.enName
        that.cnNameThree = data.cnName
      })
    },
    async selectThree () {
      let that = this
      await findHomeThree().then(res => {
        if (res.data.cnEnNameId !== null) {
          that.selectEnName(res.data.cnEnNameId)
        }
        that.homeThreeVo = res.data
      })
    },
    handleThreeClick () {
      const routeData = this.$router.resolve({
        path: this.homeThreeVo.linksVo.href,
        query: { tabId: this.homeThreeVo.linksVo.id }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style scoped>
</style>
